import { useCallback } from "react";
import { apiClient } from "@/services/apiClient";

export interface EntityLink {
  id: string;
  sourceType: string;
  sourceId: string;
  targetType: string;
  targetId: string;
  /** Display label for the target, e.g. the idea title. Serialized on
   *  calendar reads; links returned from POST /api/links omit it. */
  targetLabel?: string | null;
  year: number | null;
  createdAt: string | null;
  createdBy: string | null;
}

interface CreateLinkRequest {
  sourceType: string;
  sourceId: string;
  targetType: string;
  targetId: string;
  year?: number;
}

export function useEntityLinks(onMutate?: () => void) {
  const createLink = useCallback(
    async (params: CreateLinkRequest): Promise<EntityLink> => {
      const response = await apiClient.post<{ link: EntityLink }>(
        "/api/links",
        params,
      );
      onMutate?.();
      return response.link;
    },
    [onMutate],
  );

  const deleteLink = useCallback(
    async (linkId: string): Promise<void> => {
      await apiClient.delete(`/api/links/${linkId}`);
      onMutate?.();
    },
    [onMutate],
  );

  return { createLink, deleteLink };
}
